<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    item-text="title"
    item-value="id"
    v-bind="this.$attrs"
    :items="semesters"
    @change="onChange"
    return-object
    v-on:input="$emit('input', $event)"
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
import { Semester } from '@/plugins/api'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    semesters: [],
    loading: false
  }),
  created() {
    this.fetchAllSemesters()
  },
  computed: {
    ...mapGetters('app', ['currentSchoolYear'])
  },
  methods: {
    async fetchAllSemesters() {
      this.loading = true
      try {
        this.semesters = await Semester.fetch({ schoolYear: this.currentSchoolYear.id })
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    }
  }
}
</script>
